var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficialUserBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B88FF",
    d: "M5.598.148a.62.62 0 0 1 .804 0l1.342 1.144a.62.62 0 0 0 .352.146l1.758.14a.62.62 0 0 1 .568.568l.14 1.758c.01.13.062.253.146.352l1.144 1.342a.62.62 0 0 1 0 .804l-1.144 1.342a.619.619 0 0 0-.146.352l-.14 1.758a.62.62 0 0 1-.568.568l-1.758.14a.619.619 0 0 0-.352.146l-1.342 1.144a.62.62 0 0 1-.804 0l-1.342-1.144a.619.619 0 0 0-.352-.146l-1.758-.14a.62.62 0 0 1-.568-.568l-.14-1.758a.62.62 0 0 0-.146-.352L.148 6.402a.62.62 0 0 1 0-.804l1.144-1.342a.62.62 0 0 0 .146-.352l.14-1.758a.62.62 0 0 1 .568-.568l1.758-.14a.62.62 0 0 0 .352-.146L5.598.148z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.822 4.195a.4.4 0 0 1 .036.547L5.911 8.318a.2.2 0 0 1-.286.023L3.19 6.2a.4.4 0 0 1-.047-.551l.172-.214a.4.4 0 0 1 .576-.05l1.63 1.434a.2.2 0 0 0 .286-.024l2.239-2.741a.4.4 0 0 1 .582-.04l.194.18z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialUserBadge);
export default __webpack_public_path__ + "static/media/official_user_badge.abf3c38a7b5d57169d23c236feb10608.svg";
export { ForwardRef as ReactComponent };